
import { ResponseService } from "./response.service";
import { Injectable, Inject } from "@angular/core";
import { RouteCode } from "../../classes/route-code";

@Injectable()
export class BrowserResponseService extends ResponseService {

    private _hasSetResponseForThisRender = false;

    constructor() {
        super();
    }

    setResponseCode(code: string, redirectUrl?: string): void {

    }

    setRouteCode(code: RouteCode) {
        
    }
}